class Usercentrics {
    /**
     * Get Usercentrics CMP API (__ucCmp for v2, or usercentrics for v1)
     */
    get api() {
        // Try __ucCmp (Usercentrics v2) first
        if (window.__ucCmp) {
            return window.__ucCmp;
        }
        // Fallback to usercentrics (v1)
        return window.usercentrics || null;
    }

    /**
     * Check if consent is allowed for a specific template ID
     * @param {string} templateId - The Usercentrics template ID
     * @returns {boolean} - True if consent is granted
     */
    isConsentAllowed(templateId) {
        if (!this.api) {
            return false;
        }

        // Handle __ucCmp API (v2) - it's an object, not a function
        if (window.__ucCmp) {
            // We need to use a synchronous approach - check localStorage
            try {
                // First try ucData (v2 storage format)
                const ucData = localStorage.getItem('ucData');
                if (ucData) {
                    const data = JSON.parse(ucData);
                    const consentStatus = data.consent?.services?.[ templateId ]?.consent;
                    if (consentStatus !== undefined) {
                        return consentStatus === true;
                    }
                }

                // Fallback to uc_settings (alternative v2 format)
                const ucSettings = localStorage.getItem('uc_settings');
                if (ucSettings) {
                    const settings = JSON.parse(ucSettings);
                    const service = settings.services?.find((s) => s.id === templateId);
                    return service?.consent?.status === true;
                }
            }
            catch (e) {
                // Fallback: assume no consent
                return false;
            }
            return false;
        }

        // Handle usercentrics API (v1)
        if (this.api && typeof this.api.getConsents === 'function') {
            return this.api.getConsents(templateId).consentStatus;
        }

        return false;
    }

    isGoogleMapsConsentAllowed() {
        return this.isConsentAllowed('BJz7qNsdj-7');
    }

    isRollbarConsentAllowed() {
        return this.isConsentAllowed('tw2LlbsE8rs14I');
    }
}

export default new Usercentrics();
